export enum TOGGLE_TRACK_CHANGES_ACTION {
	TOGGLE_TRACK_CHANGES = 'TOGGLE_TRACK_CHANGES',
	RESET_BASELINE = 'RESET_BASELINE',
}
